import { BlipToasts } from 'blip-toolkit';
export var BdsToastType;
(function (BdsToastType) {
    BdsToastType["SYSTEM"] = "system";
    BdsToastType["ERROR"] = "error";
    BdsToastType["SUCCESS"] = "success";
    BdsToastType["WARNING"] = "warning";
    BdsToastType["UNDO"] = "undo";
    BdsToastType["REDO"] = "redo";
})(BdsToastType || (BdsToastType = {}));
export const BlipToastDuration = {
    WITH_TITLE: {
        'WITH_ACTION': 19000,
        'NO_ACTION': 9000,
    },
    NO_TITLE: {
        'WITH_ACTION': 16000,
        'NO_ACTION': 6000,
    },
};
export class BlipToastService {
    constructor() {
        this.TOAST_DEFAULT_DURATION = 12;
        this.toasts = new BlipToasts();
        const toastsElement = this.toasts.render();
        document.body.appendChild(toastsElement);
    }
    mapBdsToast(type) {
        const toast = {
            info: { variant: BdsToastType.SYSTEM },
            danger: { variant: BdsToastType.ERROR },
            success: { variant: BdsToastType.SUCCESS },
            warning: { variant: BdsToastType.WARNING },
            refresh: { variant: BdsToastType.SYSTEM, icon: 'refresh' },
            undo: { variant: BdsToastType.SYSTEM, icon: 'undo' },
            redo: { variant: BdsToastType.REDO, icon: 'redo' },
        };
        return toast[type];
    }
    getToastObject(type, options) {
        return {
            actionType: (options.buttonText ? 'button' : 'icon'),
            buttonAction: (options.callback ? 'custom' : 'close'),
            toastText: options.msg,
            toastTitle: options?.title,
            buttonText: options?.buttonText,
            duration: options.duration ?
                (options.duration / 1000) : options.duration ?? this.TOAST_DEFAULT_DURATION,
            position: (options.position ?? 'bottom-left'),
            ...this.mapBdsToast(type),
            icon: options?.icon,
        };
    }
    // Use this function if you want to use or replace the old toast (blip toast)
    async show(type, options) {
        const bdsToastObject = this.getToastObject(type, options);
        this.showBdsToast(bdsToastObject, options?.callback);
    }
    async showBdsToast({ actionType, buttonAction, buttonText, icon, toastText, toastTitle, variant, duration, position, }, callback) {
        const toastElement = document.createElement('bds-toast');
        document.body.appendChild(toastElement);
        await toastElement.create({
            buttonText,
            actionType,
            buttonAction,
            toastText,
            toastTitle,
            variant,
            duration,
            icon,
            position,
        });
        if (buttonAction === 'custom') {
            toastElement.addEventListener('toastButtonClick', () => {
                callback();
            });
        }
    }
}
